import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import { ARTICLE_SETTINGS_QUERY } from './articleSettings.query';
import { ArticleSettingsQuery, ArticleSettingsQueryVariables } from './__generated__/ArticleSettingsQuery';

export const useArticleSettingsLazyQuery = () => {
  return useLazyQuery<ArticleSettingsQuery, ArticleSettingsQueryVariables>(ARTICLE_SETTINGS_QUERY, {
    client: kmsClient
  });
};
